import { useEffect, useState } from "react";
import { useNavigate } from "fusion-plugin-react-router";
import { HotjarEventNames } from "../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../shared/utils/trackHotjarEvent";
import Loader from "../shared/components/Loader";
import { loginWithUber } from "../shared/services/insuranceService";

const UberAuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");

    if (!code) {
      return;
    }

    sessionStorage.setItem("uberCode", code);

    const fetchLoginDetails = async () => {
      const requestBody = {
        portalLoginProvider: "Uber",
        portalLoginInputs: {
          UberAuthorizationCode: code,
          UberRedirectUrl: `${window.location.origin}/login/uber`,
        },
      };
      TrackHotjarEvent(HotjarEventNames.PORTAL_LOGIN_REQUEST);

      try {
        if (code.length > 32) {
          const responseData = await loginWithUber(requestBody);
          sessionStorage.setItem("userSession", JSON.stringify(responseData));
          const indicator = responseData.clientLandingPageIndicator;
          if (indicator === "NewCustomer") {
            TrackHotjarEvent(
              HotjarEventNames.PORTAL_LOGIN_RESPONSE_NEW_CUSTOMER
            );
            navigate("/taxi/quote");
          } else {
            TrackHotjarEvent(
              HotjarEventNames.PORTAL_LOGIN_RESPONSE_EXISTING_CUSTOMER
            );
            navigate("/landing");
          }
        } else {
          throw new Error("Invalid Uber authorization code.");
        }
      } catch (error) {
        console.error(error);
        if (error.message && error.message.includes("404")) {
          navigate("/blocked-action?type=no-account");
        } else if (error.message && error.message.includes("400")) {
          navigate("/blocked-action?type=almost-there");
        } else {
          setErrorMessage(
            "We are unable to log you in using Uber-authentication."
          );
          navigate("/error");
        }
      }
    };

    fetchLoginDetails();
  }, [navigate]);

  return <Loader blackbg={true} text="Logging in..." />;
};

export default UberAuthCallback;
